export default "__VITE_ASSET__B8VD_wcF__"